(window["webpackJsonp"] = window["webpackJsonp"] || []).push([["main"],{

/***/ "./$$_lazy_route_resource lazy recursive":
/*!******************************************************!*\
  !*** ./$$_lazy_route_resource lazy namespace object ***!
  \******************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function webpackEmptyAsyncContext(req) {
	// Here Promise.resolve().then() is used instead of new Promise() to prevent
	// uncaught exception popping up in devtools
	return Promise.resolve().then(function() {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	});
}
webpackEmptyAsyncContext.keys = function() { return []; };
webpackEmptyAsyncContext.resolve = webpackEmptyAsyncContext;
module.exports = webpackEmptyAsyncContext;
webpackEmptyAsyncContext.id = "./$$_lazy_route_resource lazy recursive";

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html":
/*!**************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html ***!
  \**************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div fxLayout=\"column wrap\" style=\"padding: 10px;\">\r\n  <div fxLayout=\"row\">\r\n    <form name=\"inputForm\" fxFlexFill (ngSubmit)=\"calculate()\">\r\n      <mat-form-field fxFlexOffset=\"25\" fxFlex=\"50\" fxFlexOffset.xs=\"0\" fxFlexOffset.sm=\"0\" fxFlex.xs=\"100\"\r\n        fxFlex.sm=\"100\">\r\n        <mat-placeholder>Max. aantal punten</mat-placeholder>\r\n        <input matInput type=\"number\" name=\"points\" [(ngModel)]=\"maxPoints\" />\r\n        <button mat-button matSuffix mat-icon-button matTooltip=\"Reset\" (click)=\"reset()\" type=\"button\"\r\n          [disabled]=\"!testScores\">\r\n          <mat-icon>replay</mat-icon>\r\n        </button>\r\n        <button mat-button matSuffix mat-stroked-button matTooltip=\"Scores berekenen\" type=\"submit\"\r\n          [disabled]=\"!maxPoints\">\r\n          Berekenen\r\n        </button>\r\n      </mat-form-field>\r\n    </form>\r\n  </div>\r\n  <mat-tab-group *ngIf=\"testScores\">\r\n    <mat-tab label=\"Cijferlijst\">\r\n      <div fxLayout=\"row wrap\">\r\n        <mat-list *ngFor=\"let col of cols; let ci=index\" fxFlexOffset=\"{{cols.length < 2 ? 25 : 0}}\"\r\n          fxFlex=\"{{100 / max(cols.length,2)}}\" fxFlex.xs=\"100\" fxFlex.sm=\"100\" style=\"padding: 0 5px;\">\r\n          <div fxHide.xs=\"{{ci > 0}}\" fxHide.sm=\"{{ci > 0}}\">\r\n            <mat-list-item>\r\n              <div fxFlex=\"50\" class=\"bold\" matTooltip=\"Punten\">P<span fxHide=\"{{cols.length > 6}}\">unten</span></div>\r\n              <div fxFlex=\"50\" class=\"bold\" matTooltip=\"Cijfer\">C<span fxHide=\"{{cols.length > 6}}\">ijfer</span></div>\r\n            </mat-list-item>\r\n            <mat-divider></mat-divider>\r\n            <mat-divider></mat-divider>\r\n          </div>\r\n          <ng-container *ngFor=\"let ts of testScores;  let i=index\">\r\n            <div *ngIf=\"i < (ci + 1) * 10 && i >= (ci) * 10\">\r\n              <mat-list-item [class.failed]=\"ts.grade < 5.5\">\r\n                <div fxFlex=\"50\" style=\"text-align: right;\">{{ts.points}}</div>\r\n                <div fxFlex=\"50\" style=\"text-align: right;\">{{ts.grade | number: '1.1-1'}}</div>\r\n              </mat-list-item>\r\n              <mat-divider></mat-divider>\r\n            </div>\r\n          </ng-container>\r\n        </mat-list>\r\n      </div>\r\n    </mat-tab>\r\n    <mat-tab label=\"Resultaten\">\r\n      <div fxLayout=\"row wrap\">\r\n        <div fxFlex=\"30\" fxLayout=\"column\" style=\"padding: 10px; overflow-x: auto;\">\r\n          <form name=\"quickAdd\" (ngSubmit)=\"addResultManually()\" fxLayout=\"row\">\r\n            <mat-form-field fxFlex=\"60\">\r\n              <mat-label>Selecteer groep</mat-label>\r\n              <mat-select name=\"quickAddGroup\" [(ngModel)]=\"quickAddSelectedGroup\" required>\r\n                <mat-option [value]=\"g.name\" *ngFor=\"let g of testScores[0].groupResults\">{{g.name}}</mat-option>\r\n              </mat-select>\r\n            </mat-form-field>\r\n            <mat-form-field fxFlex=\"40\">\r\n              <mat-placeholder>Punten</mat-placeholder>\r\n              <input matInput type=\"number\" [min]=\"0\" required [max]=\"maxPoints\" name=\"resultToAdd\" [(ngModel)]=\"resultToAdd\" />\r\n              <button mat-button matSuffix mat-icon-button matTooltip=\"Snel resultaat toevoegen\" type=\"submit\"\r\n                [disabled]=\"!testScores && quickAdd.invalid\">\r\n                <mat-icon>add</mat-icon>\r\n              </button>\r\n            </mat-form-field>\r\n          </form>\r\n          <table cellspacing=\"0\">\r\n            <tr class=\"table-header-row\">\r\n              <th fxFlex=\"10\">\r\n                <div>Pnt.</div>\r\n              </th>\r\n              <th fxFlex=\"10\">\r\n                <div>Cijfer</div>\r\n              </th>\r\n              <th *ngFor=\"let g of testScores[0].groupResults; let i = index\" fxFlex>\r\n                <div class=\"group-name\" (mouseenter)=\"g.showButtons=true\" (mouseleave)=\"g.showButtons=false\">\r\n                  <input matInput [ngModel]=\"g.name\" (ngModelChange)=\"changeGroupName($event, g)\" />\r\n                  <span style=\"position: relative;\">\r\n                    <button mat-icon-button *ngIf=\"g.showButtons\" (click)=\"deleteGroup(g)\" [disabled]=\"i === 0\">\r\n                      <mat-icon>clear</mat-icon>\r\n                    </button>\r\n                  </span>\r\n                </div>\r\n              </th>\r\n              <th fxFlex=\"10\"><button mat-icon-button (click)=\"addGroup()\"><mat-icon>add</mat-icon></button></th>\r\n            </tr>\r\n            <tr class=\"table-data-row\" *ngFor=\"let ts of testScores\" [class.failed]=\"ts.grade < 5.5\">\r\n              <td fxFlex=\"10\" class=\"bold\" style=\"display: flex; align-items: center; justify-content: end;\">{{ts.points}}</td>\r\n              <td fxFlex=\"10\" class=\"bold\" style=\"display: flex; align-items: center; justify-content: end;\">{{ts.grade}}</td>\r\n              <td *ngFor=\"let g of ts.groupResults\" style=\"text-align:center\" fxFlex>\r\n                <button mat-icon-button class=\"mat-icon-sm\" (click)=\"removeResult(g)\">\r\n                  <mat-icon>remove</mat-icon>\r\n                </button>\r\n                <input type=\"number\" class=\"amount-results\" (click)=\"$event.target.select()\"\r\n                  [(ngModel)]=\"g.amountResults\" />\r\n                <button mat-icon-button class=\"mat-icon-sm\" (click)=\"addResult(g)\">\r\n                  <mat-icon>add</mat-icon>\r\n                </button>\r\n              </td>\r\n              <td fxFlex=\"10\"></td>\r\n            </tr>\r\n          </table>\r\n        </div>\r\n        <div fxFlex=\"70\" fxLayout=\"column\" style=\"padding: 10px;\" *ngIf=\"(groupInfo | sum:'totalResults') > 0\">\r\n          <div fxLayout=\"row\" fxLayoutAlign=\"center\">\r\n            <button mat-button mat-stroked-button (click)=\"clearGroupResults()\">\r\n              <mat-icon>clear</mat-icon>\r\n              <span>Resultaten wissen</span>\r\n            </button>\r\n          </div>\r\n          <div [chart]=\"chart\"></div>\r\n          <div fxLayout=\"row\" fxLayoutAlign=\"end\" style=\"margin-top:20px;\">\r\n            <div fxFlex=\"100\" fxFlex.gt-md=\"50\" *ngIf=\"(groupInfo | sum:'totalResults') > 0\">\r\n              <h3>Overzicht</h3>\r\n              <table cell-spacing=\"0\" class=\"table-summary\">\r\n                <tr class=\"table-header-row\">\r\n                  <th fxFlex style=\"justify-content: start\">Groep</th>\r\n                  <th fxFlex style=\"justify-content: start\">Totaal resultaten</th>\r\n                  <th fxFlex style=\"justify-content: start\">Gemiddeld pnt.</th>\r\n                  <th fxFlex style=\"justify-content: start\">Gemiddeld cijfer</th>\r\n                </tr>\r\n                <tr class=\"table-data-row\" *ngFor=\"let g of groupInfo\">\r\n                  <td fxFlex style=\"text-align: right;\">{{g.name}}</td>\r\n                  <td fxFlex style=\"text-align: right;\">{{g.totalResults}}</td>\r\n                  <td fxFlex style=\"text-align: right;\">{{(g.totalPoints / g.totalResults) | number: '1.2-2'}}</td>\r\n                  <td fxFlex style=\"text-align: right;\">{{(g.totalGrade / g.totalResults) | number: '1.2-2'}}</td>\r\n                </tr>\r\n                <tr class=\"table-footer-row\">\r\n                  <td fxFlex class=\"justify-end\">Totaal</td>\r\n                  <td fxFlex class=\"justify-end\">{{groupInfo | sum:'totalResults'}}</td>\r\n                  <td fxFlex class=\"justify-end\">{{((groupInfo | sum:'totalPoints') / (groupInfo | sum:'totalResults')) | number: '1.2-2'}}</td>\r\n                  <td fxFlex class=\"justify-end\">{{((groupInfo | sum:'totalGrade') / (groupInfo | sum:'totalResults')) | number: '1.2-2'}}</td>\r\n                </tr>\r\n              </table>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </mat-tab>\r\n  </mat-tab-group>\r\n</div>\r\n<div class=\"footer\">\r\n  <span class=\"version-number\">{{appVersion}}</span>\r\n</div>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/shared/confirm-dialog/confirm-dialog.component.html":
/*!***********************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/shared/confirm-dialog/confirm-dialog.component.html ***!
  \***********************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div>\r\n    <span [innerHtml]=\"data.text\"></span>\r\n</div>\r\n\r\n<mat-dialog-actions align=\"end\">\r\n    <button mat-button mat-dialog-close>Annuleren</button>\r\n    <button mat-button [mat-dialog-close]=\"true\">Bevestigen</button>\r\n  </mat-dialog-actions>");

/***/ }),

/***/ "./node_modules/tslib/tslib.es6.js":
/*!*****************************************!*\
  !*** ./node_modules/tslib/tslib.es6.js ***!
  \*****************************************/
/*! exports provided: __extends, __assign, __rest, __decorate, __param, __metadata, __awaiter, __generator, __exportStar, __values, __read, __spread, __spreadArrays, __await, __asyncGenerator, __asyncDelegator, __asyncValues, __makeTemplateObject, __importStar, __importDefault */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__extends", function() { return __extends; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__assign", function() { return __assign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__rest", function() { return __rest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__decorate", function() { return __decorate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__param", function() { return __param; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__metadata", function() { return __metadata; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__awaiter", function() { return __awaiter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__generator", function() { return __generator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__exportStar", function() { return __exportStar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__values", function() { return __values; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__read", function() { return __read; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spread", function() { return __spread; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spreadArrays", function() { return __spreadArrays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__await", function() { return __await; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncGenerator", function() { return __asyncGenerator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncDelegator", function() { return __asyncDelegator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncValues", function() { return __asyncValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__makeTemplateObject", function() { return __makeTemplateObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__importStar", function() { return __importStar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__importDefault", function() { return __importDefault; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}


/***/ }),

/***/ "./package.json":
/*!**********************!*\
  !*** ./package.json ***!
  \**********************/
/*! exports provided: name, version, scripts, private, dependencies, devDependencies, default */
/***/ (function(module) {

module.exports = JSON.parse("{\"name\":\"test-score-calculator\",\"version\":\"1.1.2\",\"scripts\":{\"ng\":\"ng\",\"start\":\"ng serve\",\"build\":\"ng build\",\"test\":\"ng test\",\"lint\":\"ng lint\",\"e2e\":\"ng e2e\"},\"private\":true,\"dependencies\":{\"@angular/animations\":\"~8.2.13\",\"@angular/cdk\":\"~8.2.3\",\"@angular/common\":\"~8.2.13\",\"@angular/compiler\":\"~8.2.13\",\"@angular/core\":\"~8.2.13\",\"@angular/flex-layout\":\"^8.0.0-beta.27\",\"@angular/forms\":\"~8.2.13\",\"@angular/material\":\"^8.2.3\",\"@angular/platform-browser\":\"~8.2.13\",\"@angular/platform-browser-dynamic\":\"~8.2.13\",\"@angular/router\":\"~8.2.13\",\"angular-highcharts\":\"^8.0.3\",\"highcharts\":\"^7.2.1\",\"lodash\":\"^4.17.15\",\"rxjs\":\"~6.4.0\",\"tslib\":\"^1.10.0\",\"zone.js\":\"~0.9.1\"},\"devDependencies\":{\"@angular-devkit/build-angular\":\"~0.803.17\",\"@angular/cli\":\"~8.3.17\",\"@angular/compiler-cli\":\"~8.2.13\",\"@angular/language-service\":\"~8.2.13\",\"@fortawesome/fontawesome-free\":\"^5.11.2\",\"@types/jasmine\":\"~3.3.8\",\"@types/jasminewd2\":\"~2.0.3\",\"@types/node\":\"~8.9.4\",\"codelyzer\":\"^5.0.0\",\"jasmine-core\":\"~3.4.0\",\"jasmine-spec-reporter\":\"~4.2.1\",\"karma\":\"~4.1.0\",\"karma-chrome-launcher\":\"~2.2.0\",\"karma-coverage-istanbul-reporter\":\"~2.0.1\",\"karma-jasmine\":\"~2.0.1\",\"karma-jasmine-html-reporter\":\"^1.4.0\",\"protractor\":\"~5.4.0\",\"ts-node\":\"~7.0.0\",\"tslint\":\"~5.15.0\",\"typescript\":\"~3.5.3\"}}");

/***/ }),

/***/ "./src/app/app-routing.module.ts":
/*!***************************************!*\
  !*** ./src/app/app-routing.module.ts ***!
  \***************************************/
/*! exports provided: AppRoutingModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppRoutingModule", function() { return AppRoutingModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");



const routes = [];
let AppRoutingModule = class AppRoutingModule {
};
AppRoutingModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModule"])({
        imports: [_angular_router__WEBPACK_IMPORTED_MODULE_2__["RouterModule"].forRoot(routes)],
        exports: [_angular_router__WEBPACK_IMPORTED_MODULE_2__["RouterModule"]]
    })
], AppRoutingModule);



/***/ }),

/***/ "./src/app/app.component.less":
/*!************************************!*\
  !*** ./src/app/app.component.less ***!
  \************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("input[type=\"number\"]::-webkit-inner-spin-button,\ninput[type=\"number\"]::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n.failed {\n  background-color: #ff555570;\n}\n.bold {\n  font-weight: bold;\n}\nmat-form-field.mat-form-field {\n  width: 100%;\n}\n.table-summary {\n  width: 100%;\n}\n.table-summary td {\n  padding: 8px;\n}\n.table-header-row th {\n  font-size: 14px;\n  border-bottom: 5px double lightgray;\n  padding: 15px 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.table-footer-row td {\n  font-size: 14px;\n  display: flex;\n  align-items: center;\n  font-weight: bold;\n}\n.table-data-row td {\n  border-bottom: 1px solid lightgray;\n  border-spacing: 0;\n}\n.mat-icon-sm {\n  font-size: 20px;\n  line-height: 20px;\n  color: #7a7a7a;\n}\n.amount-results {\n  display: inline-block;\n  width: 30px;\n  padding: 6px;\n  text-align: center;\n  border: none;\n  font: inherit;\n}\n.amount-results:focus {\n  outline: none;\n}\n.group-name input {\n  width: auto;\n  vertical-align: middle;\n}\n.group-name input:hover {\n  text-decoration: underline;\n  cursor: text;\n}\n.group-name button {\n  position: absolute;\n  right: 1.8rem;\n  top: -12px;\n}\n::ng-deep .mat-button .mat-button-wrapper {\n  align-items: center;\n  display: flex;\n}\n.footer {\n  position: -webkit-sticky;\n  position: sticky;\n  top: 100vh;\n  text-align: right;\n  padding-left: 5px;\n  padding-right: 5px;\n  padding-bottom: 5px;\n}\n.footer .version-number {\n  color: #eee;\n}\n.justify-end {\n  display: flex;\n  justify-content: flex-end;\n}\n\n/*# sourceMappingURL=data:application/json;base64,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 */");

/***/ }),

/***/ "./src/app/app.component.ts":
/*!**********************************!*\
  !*** ./src/app/app.component.ts ***!
  \**********************************/
/*! exports provided: AppComponent, TestScore, GroupResult */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppComponent", function() { return AppComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TestScore", function() { return TestScore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GroupResult", function() { return GroupResult; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/material */ "./node_modules/@angular/material/esm2015/material.js");
/* harmony import */ var angular_highcharts__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! angular-highcharts */ "./node_modules/angular-highcharts/fesm2015/angular-highcharts.js");
/* harmony import */ var src_environments_environment__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! src/environments/environment */ "./src/environments/environment.ts");
/* harmony import */ var _shared_confirm_dialog_confirm_dialog_component__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./shared/confirm-dialog/confirm-dialog.component */ "./src/app/shared/confirm-dialog/confirm-dialog.component.ts");






let AppComponent = class AppComponent {
    constructor(dialog) {
        this.dialog = dialog;
        this.title = "test-score-calculator";
        this.displayedColumns = ["points", "name"];
        this.appVersion = src_environments_environment__WEBPACK_IMPORTED_MODULE_4__["environment"].appVersion;
    }
    ngOnInit() { }
    calculate() {
        this.testScores = [];
        this.results = [];
        this.cols = new Array(Math.ceil((this.maxPoints + 1) / 10));
        let grade = 10;
        let points = this.maxPoints;
        this.testScores.push(new TestScore(points, grade));
        while (points > 1) {
            points--;
            grade = this.round((9 / this.maxPoints) * points + 1, 1);
            this.testScores.push(new TestScore(points, grade));
        }
        this.testScores.push(new TestScore(0, 1));
        this.quickAddSelectedGroup = this.testScores[0].groupResults[0].name;
        this.clearGroupResults();
    }
    reset() {
        this.cols = null;
        this.maxPoints = null;
        this.testScores = null;
        this.results = [];
    }
    updateChart() {
        this.buildChart();
    }
    max(...params) {
        return Math.max(...params);
    }
    round(value, precision) {
        const multiplier = Math.pow(10, precision || 0);
        return Math.round(value * multiplier) / multiplier;
    }
    addResult(testScore) {
        testScore.amountResults++;
        this.updateChart();
    }
    removeResult(testScore) {
        if (testScore.amountResults > 0) {
            testScore.amountResults--;
            this.updateChart();
        }
    }
    addResultManually() {
        if (!this.resultToAdd) {
            return;
        }
        if (this.resultToAdd <= this.maxPoints) {
            var score = this.testScores.find((ts) => ts.points === this.resultToAdd);
            var groupResults = score.groupResults.find(gr => gr.name == this.quickAddSelectedGroup);
            groupResults.amountResults++;
            this.resultToAdd = null;
            this.updateChart();
        }
    }
    addGroup() {
        var newGroupName = `Groep ${this.testScores[0].groupResults.length + 1}`;
        this.testScores.forEach((ts) => {
            var newGroup = new GroupResult(newGroupName);
            ts.groupResults.push(newGroup);
        });
    }
    deleteGroup(group) {
        const dialogRef = this.dialog.open(_shared_confirm_dialog_confirm_dialog_component__WEBPACK_IMPORTED_MODULE_5__["ConfirmDialog"], {
            data: {
                text: `Weet u zeker dat u de groep <b>'${group.name}'</b> wilt verwijderen?`,
            },
        });
        dialogRef.afterClosed().subscribe((result) => {
            if (result) {
                this.testScores.forEach((ts) => {
                    var index = ts.groupResults.findIndex((g) => g.name == group.name);
                    ts.groupResults.splice(index, 1);
                });
            }
        });
    }
    changeGroupName(event, group) {
        var oldName = group.name;
        this.testScores.forEach((ts) => {
            var g = ts.groupResults.find((g) => g.name === oldName);
            g.name = event;
        });
    }
    calculateGrouped() {
        this.groupedResults = this.groupBy(this.results, null);
        this.gradeResults = [];
        this.results.forEach((r) => {
            this.gradeResults.push(this.testScores.find((ts) => ts.points === r).grade);
        });
    }
    clearGroupResults() {
        this.testScores.forEach((ts) => ts.groupResults.forEach((gr) => (gr.amountResults = 0)));
        this.buildChart();
    }
    buildChart() {
        var categories = [];
        var data = [];
        let workSet = this.testScores.slice(0);
        workSet.sort((a, b) => {
            return a.points - b.points;
        });
        this.groupInfo = [];
        var series = workSet[0].groupResults.map((g, i) => {
            var serie = {};
            var totalResults = 0;
            var totalPoints = 0;
            var totalGrade = 0;
            serie.name = g.name;
            serie.data = workSet.map((ts) => {
                totalResults += ts.groupResults[i].amountResults;
                totalPoints += ts.groupResults[i].amountResults * ts.points;
                totalGrade += ts.groupResults[i].amountResults * ts.grade;
                return ts.groupResults[i].amountResults;
            });
            this.groupInfo.push({
                name: serie.name,
                totalResults: totalResults,
                totalPoints: totalPoints,
                totalGrade: totalGrade
            });
            return serie;
        });
        workSet.forEach((ts) => {
            categories.push(ts.points);
            data.push(ts.amountResults);
        });
        let chart = new angular_highcharts__WEBPACK_IMPORTED_MODULE_3__["Chart"]({
            chart: {
                type: "column",
            },
            title: {
                text: "Resultaten",
            },
            credits: {
                enabled: true,
            },
            xAxis: {
                tickWidth: 0,
                lineWidth: 3,
                tickInterval: 5,
                title: {
                    text: "Aantal behaalde punten",
                },
                opposite: false,
                categories: categories,
            },
            yAxis: {
                tickInterval: 5,
                min: 0,
                max: 30,
                lineWidth: 0,
                opposite: true,
                labels: {
                    format: "{value}",
                },
                title: {
                    text: "Aantal leerlingen",
                },
            },
            tooltip: {
                headerFormat: '<span style="font-size:14px">{point.key} pnt.</span><table>',
                pointFormat: "<tr>" +
                    '   <td style="color:{series.color};padding:0">{series.name}: </td>' +
                    '   <td style="padding:0;text-align:right"><b>{point.y}</b></td>' +
                    "</tr>",
                footerFormat: "</table>",
                shared: true,
                useHTML: true,
            },
            plotOptions: {
                column: {
                    dataLabels: {
                        enabled: false,
                    },
                    borderWidth: 2,
                },
            },
            series: series,
        });
        this.chart = chart;
    }
    groupBy(xs, key) {
        return xs.reduce((rv, x) => {
            if (key && x == Object(x)) {
                // Complex type
                (rv[x[key]] = rv[x[key]] || []).push(x);
            }
            else {
                // Simple type
                let y = x.toString();
                (rv[y] = rv[y] || []).push(x);
            }
            return rv;
        }, {});
    }
};
AppComponent.ctorParameters = () => [
    { type: _angular_material__WEBPACK_IMPORTED_MODULE_2__["MatDialog"] }
];
AppComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: "app-root",
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./app.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./app.component.less */ "./src/app/app.component.less")).default]
    })
], AppComponent);

class TestScore {
    constructor(points, grade) {
        this.points = points;
        this.grade = grade;
        this.amountResults = 0;
        this.groupResults = [];
        let defaultGroup = new GroupResult("Groep 1");
        this.groupResults.push(defaultGroup);
    }
}
class GroupResult {
    constructor(name) {
        this.name = name;
        this.amountResults = 0;
    }
}


/***/ }),

/***/ "./src/app/app.module.ts":
/*!*******************************!*\
  !*** ./src/app/app.module.ts ***!
  \*******************************/
/*! exports provided: AppModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppModule", function() { return AppModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _shared_shared_module__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./shared/shared.module */ "./src/app/shared/shared.module.ts");
/* harmony import */ var _angular_platform_browser__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/platform-browser */ "./node_modules/@angular/platform-browser/fesm2015/platform-browser.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/material */ "./node_modules/@angular/material/esm2015/material.js");
/* harmony import */ var _angular_flex_layout__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/flex-layout */ "./node_modules/@angular/flex-layout/esm2015/flex-layout.js");
/* harmony import */ var _app_routing_module__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./app-routing.module */ "./src/app/app-routing.module.ts");
/* harmony import */ var _app_component__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./app.component */ "./src/app/app.component.ts");
/* harmony import */ var _angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @angular/platform-browser/animations */ "./node_modules/@angular/platform-browser/fesm2015/animations.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var angular_highcharts__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! angular-highcharts */ "./node_modules/angular-highcharts/fesm2015/angular-highcharts.js");











let AppModule = class AppModule {
};
AppModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_3__["NgModule"])({
        declarations: [
            _app_component__WEBPACK_IMPORTED_MODULE_7__["AppComponent"],
        ],
        imports: [
            _angular_platform_browser__WEBPACK_IMPORTED_MODULE_2__["BrowserModule"],
            _angular_forms__WEBPACK_IMPORTED_MODULE_9__["FormsModule"],
            _app_routing_module__WEBPACK_IMPORTED_MODULE_6__["AppRoutingModule"],
            _angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_8__["BrowserAnimationsModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_4__["MatCardModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_4__["MatIconModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_4__["MatToolbarModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_4__["MatButtonModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_4__["MatFormFieldModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_4__["MatInputModule"],
            _angular_flex_layout__WEBPACK_IMPORTED_MODULE_5__["FlexLayoutModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_4__["MatTableModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_4__["MatListModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_4__["MatDividerModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_4__["MatTooltipModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_4__["MatTabsModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_4__["MatChipsModule"],
            angular_highcharts__WEBPACK_IMPORTED_MODULE_10__["ChartModule"],
            _shared_shared_module__WEBPACK_IMPORTED_MODULE_1__["SharedModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_4__["MatDialogModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_4__["MatSelectModule"]
        ],
        providers: [],
        bootstrap: [_app_component__WEBPACK_IMPORTED_MODULE_7__["AppComponent"]]
    })
], AppModule);



/***/ }),

/***/ "./src/app/shared/confirm-dialog/confirm-dialog.component.ts":
/*!*******************************************************************!*\
  !*** ./src/app/shared/confirm-dialog/confirm-dialog.component.ts ***!
  \*******************************************************************/
/*! exports provided: ConfirmDialog */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ConfirmDialog", function() { return ConfirmDialog; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/material */ "./node_modules/@angular/material/esm2015/material.js");



let ConfirmDialog = class ConfirmDialog {
    constructor(data) {
        this.data = data;
    }
};
ConfirmDialog.ctorParameters = () => [
    { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"], args: [_angular_material__WEBPACK_IMPORTED_MODULE_2__["MAT_DIALOG_DATA"],] }] }
];
ConfirmDialog = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'confirm-dialog',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./confirm-dialog.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/shared/confirm-dialog/confirm-dialog.component.html")).default,
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__param"](0, Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"])(_angular_material__WEBPACK_IMPORTED_MODULE_2__["MAT_DIALOG_DATA"]))
], ConfirmDialog);



/***/ }),

/***/ "./src/app/shared/shared.module.ts":
/*!*****************************************!*\
  !*** ./src/app/shared/shared.module.ts ***!
  \*****************************************/
/*! exports provided: SharedModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SharedModule", function() { return SharedModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _sort_by_pipe__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./sort-by.pipe */ "./src/app/shared/sort-by.pipe.ts");
/* harmony import */ var _sum_pipe__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./sum.pipe */ "./src/app/shared/sum.pipe.ts");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
/* harmony import */ var _confirm_dialog_confirm_dialog_component__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./confirm-dialog/confirm-dialog.component */ "./src/app/shared/confirm-dialog/confirm-dialog.component.ts");
/* harmony import */ var _angular_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @angular/material */ "./node_modules/@angular/material/esm2015/material.js");







let SharedModule = class SharedModule {
};
SharedModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_3__["NgModule"])({
        declarations: [
            _sum_pipe__WEBPACK_IMPORTED_MODULE_2__["SumPipe"],
            _sort_by_pipe__WEBPACK_IMPORTED_MODULE_1__["SortByPipe"],
            _confirm_dialog_confirm_dialog_component__WEBPACK_IMPORTED_MODULE_5__["ConfirmDialog"]
        ],
        entryComponents: [
            _confirm_dialog_confirm_dialog_component__WEBPACK_IMPORTED_MODULE_5__["ConfirmDialog"]
        ],
        imports: [
            _angular_common__WEBPACK_IMPORTED_MODULE_4__["CommonModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_6__["MatButtonModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_6__["MatDialogModule"]
        ],
        exports: [
            _sum_pipe__WEBPACK_IMPORTED_MODULE_2__["SumPipe"],
            _sort_by_pipe__WEBPACK_IMPORTED_MODULE_1__["SortByPipe"]
        ]
    })
], SharedModule);



/***/ }),

/***/ "./src/app/shared/sort-by.pipe.ts":
/*!****************************************!*\
  !*** ./src/app/shared/sort-by.pipe.ts ***!
  \****************************************/
/*! exports provided: SortByPipe */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SortByPipe", function() { return SortByPipe; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lodash */ "./node_modules/lodash/lodash.js");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_2__);



let SortByPipe = class SortByPipe {
    transform(value, order = '', column = '') {
        if (!value || order === '' || !order) {
            return value;
        } // no array
        if (!column || column === '') {
            return lodash__WEBPACK_IMPORTED_MODULE_2__["sortBy"](value);
        } // sort 1d array
        if (value.length <= 1) {
            return value;
        } // array with only one item
        value.forEach(v => {
            v['p' + column] = +v[column];
        });
        return lodash__WEBPACK_IMPORTED_MODULE_2__["orderBy"](value, ['p' + column], [order]);
    }
};
SortByPipe = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Pipe"])({
        name: 'sortBy'
    })
], SortByPipe);



/***/ }),

/***/ "./src/app/shared/sum.pipe.ts":
/*!************************************!*\
  !*** ./src/app/shared/sum.pipe.ts ***!
  \************************************/
/*! exports provided: SumPipe */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SumPipe", function() { return SumPipe; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let SumPipe = class SumPipe {
    transform(items, attr) {
        if (!items) {
            return 0;
        }
        if (attr) {
            return items.reduce((a, b) => a + b[attr], 0);
        }
        else {
            return items.reduce((a, b) => a + b, 0);
        }
    }
};
SumPipe = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Pipe"])({
        name: 'sum',
        pure: false
    })
], SumPipe);



/***/ }),

/***/ "./src/environments/environment.ts":
/*!*****************************************!*\
  !*** ./src/environments/environment.ts ***!
  \*****************************************/
/*! exports provided: environment */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "environment", function() { return environment; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

const environment = {
    production: false,
    appVersion: __webpack_require__(/*! ../../package.json */ "./package.json").version
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.


/***/ }),

/***/ "./src/main.ts":
/*!*********************!*\
  !*** ./src/main.ts ***!
  \*********************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_platform_browser_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/platform-browser-dynamic */ "./node_modules/@angular/platform-browser-dynamic/fesm2015/platform-browser-dynamic.js");
/* harmony import */ var _app_app_module__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./app/app.module */ "./src/app/app.module.ts");
/* harmony import */ var _environments_environment__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./environments/environment */ "./src/environments/environment.ts");





if (_environments_environment__WEBPACK_IMPORTED_MODULE_4__["environment"].production) {
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["enableProdMode"])();
}
Object(_angular_platform_browser_dynamic__WEBPACK_IMPORTED_MODULE_2__["platformBrowserDynamic"])().bootstrapModule(_app_app_module__WEBPACK_IMPORTED_MODULE_3__["AppModule"])
    .catch(err => console.error(err));


/***/ }),

/***/ 0:
/*!***************************!*\
  !*** multi ./src/main.ts ***!
  \***************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! D:\git_repos\NifNic.TestScoreCalculator\src\main.ts */"./src/main.ts");


/***/ })

},[[0,"runtime","vendor"]]]);
//# sourceMappingURL=main-es2015.js.map